const fenderData = {
    "segmentDev": "y1awVYoBbgV9lG7S6y259hFWqubTwipu",
    "segmentProd": "rwYDIGRVRM5Wr4XKyikDSLcmwg00sTtR"
};

export default fenderData;